var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownres(_ref, svgRef) {
  var {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 5,
    viewBox: "0 0 8 5",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.0511043 0.660062C0.0253865 0.604905 0.0125 0.545788 0.0125 0.482562C0.0125 0.355722 0.0552741 0.245817 0.141058 0.152252L0.141059 0.152251C0.226305 0.0592535 0.33865 0.0125 0.479353 0.0125H7.52065C7.66131 0.0125 7.77364 0.0596845 7.8589 0.153586C7.94474 0.248125 7.9875 0.358069 7.9875 0.483968C7.9875 0.489743 7.98507 0.501034 7.97887 0.519061C7.97283 0.53662 7.96368 0.559275 7.95134 0.58712C7.92682 0.642451 7.89002 0.717556 7.84087 0.812528L4.50008 4.15332C4.42413 4.22926 4.34599 4.28434 4.26571 4.31895C4.1854 4.35357 4.09689 4.37097 4 4.37097C3.90311 4.37097 3.8146 4.35357 3.73429 4.31895C3.65401 4.28434 3.57587 4.22925 3.49992 4.15329L3.49108 4.16213L3.49992 4.15329L0.157548 0.810944C0.112433 0.765829 0.0769813 0.715542 0.0511043 0.660062ZM0.0511043 0.660062C0.0511045 0.660062 0.0511047 0.660063 0.0511049 0.660063L0.0511043 0.660062Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.025
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownres);
export default __webpack_public_path__ + "static/media/downres.65406620826047702f306c9b0eef0e44.svg";
export { ForwardRef as ReactComponent };